import PropTypes from "prop-types";
import React from "react";

/**
 * Renders a shape. TODO - build this out to render a large variety of predefined shapes, or shapes
 * with new definitions.
 */
export const Shape = (props) => {
  const { className, color, onClick, shape = "circle", stroke } = props;

  return (
    <div
      className={className}
      style={{
        backgroundColor: color,
        borderColor: stroke ? `1px solid ${stroke}` : undefined,
        borderRadius: shape === "circle" ? "50%" : 0,
      }}
      onClick={onClick}
    />
  );
};

Shape.displayName = "Shape";

Shape.propTypes = {
  /** Additional classes for positioning the component. */
  className: PropTypes.string,

  /** Fill color. */
  color: PropTypes.string,

  /** Event handler to be called if Shape is clicked. */
  onClick: PropTypes.func,

  /** Shape to be rendered. */
  shape: PropTypes.string,

  /** Stroke color. */
  stroke: PropTypes.string,
};
